import React from 'react'
import Skeleton from 'react-loading-skeleton'

const LeftScreenSkeleton = () => {
    return (
        <>
            <div className="container ">
                <div style={{ width: '90%' }}>
                    {[1, 2, 3].map(item => <Skeleton key={item} width={item === 1 ? '50%' : 'default'} />)}
                </div>
            </div>
            <div className="container mb-5">
                <div className="form-group">
                    <Skeleton height='3em' />
                </div>
            </div>
            <div className="container">
                <Skeleton width='45%' /><br />
                <div className="container">
                    <div className="row" style={{ justifyContent: 'space-between', flexWrap: 'nowrap' }}>
                        {[1, 2, 3].map(item => <div key={item} className="users px-0">
                            <Skeleton />
                        </div>)}
                    </div>
                </div>
            </div>
        </>
    )
}

export default LeftScreenSkeleton